import { render, staticRenderFns } from "./FindBox.vue?vue&type=template&id=50fa0f9d&scoped=true&"
import script from "./FindBox.vue?vue&type=script&lang=js&"
export * from "./FindBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fa0f9d",
  null
  
)

export default component.exports